import React from "react";

//UI Material
import { Box } from "@mui/material";

//React Charts js
import { Line } from "react-chartjs-2";
import {
  Chart as ChartsJS,
  CategoryScale,
  LinearScale,
  LineElement,
  LineController,
  BarElement,
  Title,
  Tooltip,
  Legend,
  PointElement,
} from "chart.js";

//Helpers
import {
  checkOrderStatus,
  getFilteredTOrdersByDateRangeFromLocalTimeStrings,
} from "../../Helpers/orderFunctions";
import { evstations } from "../../Helpers/productSelector";

ChartsJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  LineController,
  Title,
  Tooltip,
  Legend
);

export default function AllMonthlySalesGraph({ data = [], year, product }) {
  //Function to select only the valid order according to product category
  const selectValidOrders = () => {
    switch (product) {
      case "estaciones":
        return data.filter((order) => evstations.includes(order.productName));
      case "accesorios":
        return data.filter((order) => !evstations.includes(order.productName));
      case "todos":
        return data;
      default:
        return data;
    }
  };

  //Function to get the orders
  const extractedInfo = getFilteredTOrdersByDateRangeFromLocalTimeStrings(
    selectValidOrders(),
    `1/1/${year}`,
    `12/31/${year}`,
    "finishedAt"
  );

  //Function to generate graph datasets
  const generateDataSets = () => {
    let products = [
      {
        label: "Ventas en Dólares (USD)",
        data: new Array(12).fill(0),
        backgroundColor: new Array(12).fill("#000"),
        borderColor: new Array(12).fill("#000"),
        tension: 0.2,
      },
    ];

    //Fill order objects iterating trough orders
    for (const order of extractedInfo) {
      try {
        const month = new Date(order.finishedAt).getMonth();
        //Validate month
        if (!isNaN(Number(month))) {
          if (
            checkOrderStatus(order.productsStatus, order.canceledBy) ===
            "Finalizada"
          ) {
            products[0].data[month] += Number(order.billing.amount);
          }
        }
      } catch (e) {
        console.log(e);
        break;
      }
    }

    products[0].borderColor[new Date().getMonth()] = "#00B4B4";
    products[0].backgroundColor[new Date().getMonth()] = "#00B4B4";

    return products;
  };

  //Function to generate chart data
  const generateChartData = () => ({
    datasets: generateDataSets(),
    labels: [
      "Ene",
      "Feb",
      "Mar",
      "Abr",
      "May",
      "Jun",
      "Jul",
      "Ago",
      "Set",
      "Oct",
      "Nov",
      "Dic",
    ],
  });

  //Function to generate chart options
  const generateChartOptions = () => ({
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      y: { beginAtZero: true },
    },
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 15,
        },
      },
      title: {
        display: true,
        text: `Total de ventas registradas para cada mes del año`,
      },
    },
  });

  return (
    <Box sx={{ minHeight: "250px" }}>
      <Line options={generateChartOptions()} data={generateChartData()} />
    </Box>
  );
}
